import { DefaultTheme, ThemeProps } from 'styled-components';
import { TokenName } from '@mews/design-tokens';
import { ComponentTokens, DesignToken } from '../types';
import { getToken } from './getToken';

// TODO - Simplify this utility function and update docs - https://mews.atlassian.net/wiki/spaces/DSY/pages/200900974/getComponentToken+utility
// https://github.com/MewsSystems/mews-js/pull/22332#discussion_r1793538356
export const getComponentToken =
    <
        Variant extends string,
        State extends string,
        Values extends string,
        Tokens extends ComponentTokens<Variant, State, Values>,
        Props,
    >(
        tokens: Tokens,
        stateCallback: (props: Props) => { variant: Variant; state: State }
    ) =>
    <P extends keyof Tokens, S extends keyof Tokens[P]>(property: P, interactionState: S = 'default' as S) =>
    (props: Props & ThemeProps<DefaultTheme>) => {
        const { variant, state } = stateCallback(props);
        const token = (tokens[property]?.[interactionState] as Record<Variant, Record<State, Values>>)?.[variant]?.[
            state
        ];

        if (token === undefined) {
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn(
                    `Token not found for property: ${String(property)}, interactionState: ${String(
                        interactionState
                    )}, variant: ${String(variant)}, state: ${String(state)}`
                );
            }

            return;
        }

        if (token in TokenName) {
            return getToken(token as DesignToken)(props);
        }

        return token;
    };
